var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.768,
    height: 23.076,
    viewBox: "0 0 20.768 23.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "translating",
    transform: "translate(-20.752 -70.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25297",
    "data-name": "Path 25297",
    d: "M183.1,240h-2.15a15.4,15.4,0,0,0,.192,1.958Z",
    transform: "translate(-154.695 -158.471)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25298",
    "data-name": "Path 25298",
    d: "M101.328,149.948a32.811,32.811,0,0,1-3.621-.8,10.331,10.331,0,0,0-1.486,4.861h4.462A16.327,16.327,0,0,1,101.328,149.948Z",
    transform: "translate(-75.469 -73.52)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25299",
    "data-name": "Path 25299",
    d: "M185.3,166.522v-2.476a32.985,32.985,0,0,1-3.71-.27,15.287,15.287,0,0,0-.644,3.911h3.189Z",
    transform: "translate(-154.689 -87.197)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25300",
    "data-name": "Path 25300",
    d: "M134.475,76.37a10.332,10.332,0,0,0-5.849,3.819,31.816,31.816,0,0,0,3.329.706,16.131,16.131,0,0,1,2.521-4.525Z",
    transform: "translate(-105.769 -5.467)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25301",
    "data-name": "Path 25301",
    d: "M199.5,77.378V72.2c-.108.005-.216.013-.324.022a15.144,15.144,0,0,0-3.044,4.922,31.959,31.959,0,0,0,3.369.234Z",
    transform: "translate(-168.887 -1.568)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25302",
    "data-name": "Path 25302",
    d: "M267.182,76.67a15.2,15.2,0,0,0-2.857-4.45c-.108-.009-.216-.016-.325-.022v5.178c.878-.014,1.759-.066,2.628-.152Z",
    transform: "translate(-232.351 -1.566)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25303",
    "data-name": "Path 25303",
    d: "M297.034,78.1a10.312,10.312,0,0,0-3.741-1.74,16.193,16.193,0,0,1,2.07,3.411Z",
    transform: "translate(-259.742 -5.46)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25304",
    "data-name": "Path 25304",
    d: "M264,167.094v1.437l1.495-1.495Q264.748,167.082,264,167.094Z",
    transform: "translate(-232.351 -90.245)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25305",
    "data-name": "Path 25305",
    d: "M100.672,240H96.209a10.411,10.411,0,0,0,2.01,5.643l2.795-2.794A16.409,16.409,0,0,1,100.672,240Z",
    transform: "translate(-75.457 -158.471)",
    fill: "#200e32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25306",
    "data-name": "Path 25306",
    d: "M175.636,137.11l-14.529,14.529a10.316,10.316,0,0,0,5.124,1.972,10.554,10.554,0,0,0,2.077,0c.143-.014.29-.032.447-.055a.52.52,0,0,1,.593.514v1.9l3.8-4.112a.525.525,0,0,1,.084-.073,10.393,10.393,0,0,0,2.731-14.214Q175.8,137.338,175.636,137.11Zm-8.366,12.4a1.039,1.039,0,1,1,1.039-1.039A1.039,1.039,0,0,1,167.269,149.506Zm3.117,0a1.039,1.039,0,1,1,1.039-1.039A1.039,1.039,0,0,1,170.386,149.506Zm3.117,0a1.039,1.039,0,1,1,1.039-1.039A1.039,1.039,0,0,1,173.5,149.506Z",
    transform: "translate(-136.14 -62.262)",
    fill: "#200e32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslating);
export default __webpack_public_path__ + "static/media/translating.0144a3cdb7995b9cf71d492fe721e60b.svg";
export { ForwardRef as ReactComponent };